import { RouteComponentProps } from "react-router"

export const getPathParams = (params: RouteComponentProps) =>
  params.match.params as any
